import React, { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import Loader from "../components/Loader";
import { userLogout } from "../redux/Actions/userAction";
import api from "../redux/service/api";
// import { logout } from "../redux/Actions/userAction"; // Ensure you have a logout action

const RequireAuth = ({ children }) => {
  const [checkingAuth, setCheckingAuth] = useState(true);
  const { loading, userInfo } = useSelector((state) => state.userLogin);

  const dispatch = useDispatch();

  useEffect(() => {
    const verifyToken = async () => {
      if (!userInfo) {
        setCheckingAuth(false);
        return;
      }
      try {
        const { data } = await api.get("api/auth/validate-token");

        if (
          !userInfo.tokenVersion ||
          data.tokenVersion !== userInfo.tokenVersion
        ) {
          console.log("Logging out user >>>>>>>>>>>>>>>>>>>>>>>>", userInfo);
          dispatch(userLogout());
          localStorage.removeItem("userInfo");
          setCheckingAuth(false);
        } else {
          setCheckingAuth(false);
        }
      } catch (error) {
        dispatch(userLogout());
        localStorage.removeItem("userInfo");
        setCheckingAuth(false);
      }
    };

    verifyToken();
  }, [dispatch, userInfo]);

  if (loading || checkingAuth) {
    return <Loader />;
  }

  if (!userInfo) {
    return <Navigate to="/login" />;
  }

  return children;
};

export default RequireAuth;
